import { render, staticRenderFns } from "./EvenBg.vue?vue&type=template&id=5e22af95&"
import script from "./EvenBg.vue?vue&type=script&lang=js&"
export * from "./EvenBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports